<script setup lang="ts">
import { computed, ref } from 'vue'

const open = ref(false)
const anchor = ref({ left: 0, top: 0, width: 1 })

const anchorStyle = computed(() => ({
  position: 'fixed' as const,
  left: `${anchor.value.left}px`,
  top: `${anchor.value.top}px`,
  width: `${anchor.value.width}px`,
  height: '1px',
  pointerEvents: 'none' as const,
}))

function position(event?: Event) {
  const target = event?.currentTarget
  if (!(target instanceof Element)) return
  const rect = target.getBoundingClientRect()
  anchor.value = { left: rect.left, top: rect.bottom, width: rect.width }
}

function toggle(event?: Event) {
  position(event)
  open.value = !open.value
}

function show(event?: Event) {
  position(event)
  open.value = true
}

function hide() {
  open.value = false
}

defineExpose({ toggle, show, hide })
</script>

<template>
  <UPopover v-model:open="open" :content="{ align: 'start', side: 'bottom', sideOffset: 4 }">
    <span :style="anchorStyle" aria-hidden="true" />
    <template #content>
      <div class="max-h-[min(32rem,80vh)] overflow-auto">
        <slot />
      </div>
    </template>
  </UPopover>
</template>
